/*
 * @Description: ***页面
 * @Date: 2022-12-12 14:35:39
 * @Author: hkr
 * @LastEditors: hkr
 */
import { combineReducers } from '@reduxjs/toolkit'
import globalReducer from './modules/global.store'
import userReducer from './modules/user.store'

const rootReducer = combineReducers({
  global: globalReducer,
  user: userReducer
})

export default rootReducer
